import { INVITE_PATH_PREFIX, WaitlistInviteCode } from "@pax/api-contract/waitlist/v1alpha1";

/** The link an invite opens, on this origin. */
export function inviteLink(code: string): string {
  return `${window.location.origin}${INVITE_PATH_PREFIX}${code}`;
}

/** The code in a pasted invite link, or a code pasted on its own; null when it's neither. */
export function inviteCodeFrom(pasted: string): string | null {
  const text = pasted.trim();
  const index = text.indexOf(INVITE_PATH_PREFIX);
  const candidate = (index === -1 ? text : text.slice(index + INVITE_PATH_PREFIX.length))
    .split(/[/?#]/)[0]
    ?.toLowerCase();
  return WaitlistInviteCode.safeParse(candidate).success ? (candidate ?? null) : null;
}
